module.exports = __webpack_public_path__ + "static/media/V65.32e95469.png";